import { GlobalStyle } from "./styles/GlobalStyle";
import Router from "./Router";
import React from "react";

function App() {
  return (
    <React.Fragment>
      <GlobalStyle />
      <Router />
    </React.Fragment>
  );
}

export default App;
